
import React, { useState }  from 'react';
//import logo from './logo.svg';
import './App.css'; 
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './global';
import { theme } from './theme';
import { Burger, Menu } from './components';
import Wave from 'react-wavify';
import './App.scss';
function App() {
  const [open, setOpen] = useState(false);
  return (
  
   <ThemeProvider class="body" theme={theme}>
      <>
        <GlobalStyles />

        <div>
          <Burger open={open} setOpen={setOpen} />
          <Menu open={open} setOpen={setOpen} />
        </div>
        <div class="footer">
                <div class="social_media">
                  <a class="btn btn-icon btn-facebook" href="#"><i class="fa fa-facebook"></i><span>Facebook</span></a>
                  <a class="btn btn-icon btn-googleplus" href="#"><i class="fa fa-google-plus"></i><span>Google+</span></a>
                  <a class="btn btn-icon btn-linkedin" href="#"><i class="fa fa-linkedin"></i><span>LinkedIn</span></a>
                </div>

                <Wave mask="url(#mask)" fill="#1277b0" >
                <defs>
                <linearGradient id="gradient" gradientTransform="rotate(90)">
                  <stop offset="0" stopColor="white" />
                  <stop offset="0.5" stopColor="black" />
                </linearGradient>
                <mask id="mask">
                <rect x="0" y="0" width="100%" height="600" fill="url(#gradient)"  />
                </mask>
                </defs>
                </Wave>

        </div>
      </>
    </ThemeProvider>
  
  );
}

export default App;
    